import React, { useEffect, useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Stack } from "@mui/material";
import SalesRepForm from "./SalesRepForm";
import { InternalUser } from "../../types/app";
import { defaultThreeRepsEntries } from "./helpers";

type Props = {
  open: boolean;
  onClose: () => void;
  onSave: (salesRepsIds: string[]) => void;
  initialSalesReps?: (InternalUser | null)[];
};

const SalesRepModal = ({ open, onClose, onSave, initialSalesReps = [null, null, null] }: Props) => {
  const [salesReps, setSalesReps] = useState<(InternalUser | null)[]>(defaultThreeRepsEntries(initialSalesReps));

  const resetModalAndHandleClose = () => {
    setSalesReps([null, null, null]);
    onClose();
  };

  useEffect(() => {
    if (open) {
      setSalesReps(defaultThreeRepsEntries(initialSalesReps));
    }
  }, [initialSalesReps, open]);

  return (
    <Dialog open={open} onClose={resetModalAndHandleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Edit Sales Reps</DialogTitle>
      <DialogContent>
        <Stack spacing={3} mt={1} mb={2}>
          <SalesRepForm salesReps={defaultThreeRepsEntries(salesReps)} setSalesReps={setSalesReps} />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={resetModalAndHandleClose}>Cancel</Button>
        <Button
          variant="contained"
          onClick={() => {
            const validSalesReps = salesReps.map((s) => s?.salesRepId || "").filter(Boolean);
            onSave(validSalesReps);
            resetModalAndHandleClose();
          }}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SalesRepModal;
